import * as React from "react"
import styled from "@emotion/styled"
import { theme, vh, rr } from "../../styles/styleGuide"
import Gmail from "../../assets/mobile/svg/gmail.inline.svg"
import Linked from "../../assets/mobile/svg/linked.inline.svg"
import Skype from "../../assets/mobile/svg/skype.inline.svg"
import Behance from "../../assets/mobile/svg/behance.inline.svg"
import PlusLines from "../../assets/mobile/svg/plusButton.inline.svg"
import ScrollToPlugin from "gsap/ScrollToPlugin"
import SignatureSvg from "../../assets/mobile/svg/signature.inline.svg"
import gsap from "gsap"
gsap.registerPlugin(ScrollToPlugin)
var color = theme.color,
  font = theme.font

const PlusContainer: React.FC = ({ children }) => {
  // React.useEffect(() => {
  //   gsap.set("#plus-button", { y: vh(-100) })
  // }, [])

  return (
    <Container id="plus-container">
      <SlidesContainer className="slides-container">{children}</SlidesContainer>
      <Clip className="extra-menu">
        <Credits />
        <MediaButtons />
        <Border />
      </Clip>
      <PlusButton />
    </Container>
  )
}
const Container = styled.div`
  position: fixed;
  z-index: 0;
  top: 0;
  width: 100vw;
  ${rr("height", "vh", 100)}
  overflow: hidden;
`
const SlidesContainer = styled.main`
  position: absolute;
  left: 0vw;
  ${rr("top", "vh", 10)}
  ${rr("height", "vh", 90)}
  width: 100vw;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.white}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Clip = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  ${rr("height", "vh", 90)}
  clip-path: inset(0% 0% 100% 0%);
  background-color: ${color.black};
  display: none;
  pointer-events: none;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`
const PlusButton = () => {
  const Holder = styled.div`
    position: absolute;
    z-index: 100;
    width: 100vw;
    ${rr("height", "vh", 10)}
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: ${color.white};
  `
  const Line = styled.div`
    width: 12vw;
    height: 1.3vw;
    margin-bottom: 1.3vw;
    /* ${rr("width", "px", 40, 40, 50)}
    ${rr("height", "px", 4, 5, 7)} */
    /* ${rr("margin-bottom", "px", 7, 5, 8)} */
    background-color: ${color.black};
    border-radius: 0px 50px;
  `
  const LineHolder = styled.div`
    height: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1.5vh;
  `
  var toggleState: "up" | "down" = "up"
  const toggle = () => {
    const creditsReveal = (time: number) => {
      gsap.to(".extra-menu .credits-contianer", {
        id: "credits-reveal",
        duration: time,
        ease: "none",
        scrollTo: {
          y: "max",
          autoKill: true,
          onAutoKill: () => {
            gsap.delayedCall(2, () => {
              var totalScroll = document.querySelector(".extra-menu .credits-contianer")
                  ?.scrollHeight,
                currentScroll = document.querySelector(".extra-menu .credits-contianer")?.scrollTop,
                scrollMargin = document.querySelector(".extra-menu .credits-contianer")
                  ?.clientHeight,
                scrollTime = 30 * ((totalScroll! - currentScroll! - scrollMargin!) / totalScroll!)
              creditsReveal(scrollTime)
              console.log(
                "totalScroll: ",
                totalScroll,
                "     currentScroll: ",
                currentScroll,
                "    Scroll Margin:",
                scrollMargin,
                "    new Time:",
                scrollTime
              )
            })
          },
        },
      })
    }
    if (toggleState === "up") {
      gsap
        .timeline()
        .set("#plus-container .extra-menu ", {
          display: "flex",
          pointerEvents: "all",
        })
        .add("l1")
        .to(
          "#plus-container .extra-menu",
          {
            duration: 1.7,
            ease: "expo.out",
            clipPath: "inset(0% 0% 0% 0%)",
          },
          "l1"
        )
        .to(
          "#plus-button",
          {
            duration: 2,
            ease: "expo.out",
            y: "0vh",
            onStart: () => {
              toggleState = "down"
            },
          },
          "l1"
        )
        .to(
          "#plus-button .text.l-1",
          { duration: 1, ease: "expo.in", rotate: -45, y: "190%", borderRadius: "50px" },
          "l1"
        )
        .to("#plus-button .text.l-2", { duration: 1, ease: "expo.in", opacity: 0 }, "l1")
        .to(
          "#plus-button .text.l-3",
          {
            duration: 1,
            ease: "expo.in",
            rotate: 45,
            y: "-190%",
            borderRadius: "50px",
            onComplete: () => {
              creditsReveal(30)
            },
          },
          "l1"
        )
        .set(".slides-container", { display: "none" })
    }
    if (toggleState === "down") {
      gsap
        .timeline()
        .set(".slides-container", { display: "initial" })
        .add("l1")
        .to(
          "#plus-container .extra-menu",
          {
            duration: 2.2,
            ease: "expo.out",
            clipPath: "inset(0% 0% 100% 0%)",
            pointerEvents: "none",
          },
          "l1"
        )
        .to(
          "#plus-button",
          {
            duration: 2,
            ease: "expo.out",
            y: vh(-90),
            onStart: () => {
              toggleState = "up"
            },
          },
          "l1"
        )
        .to(
          "#plus-button .text",
          {
            duration: 1,
            ease: "expo.in",
            rotate: 0,
            opacity: 1,
            y: 0,
            borderRadius: "0px 50px",
          },
          "l1"
        )
        .to(".extra-menu .credits-contianer", {
          delay: -1,
          duration: 0.1,
          scrollTo: { y: 0 },
          onStart: () => {
            if (gsap.getById("credits-reveal")) {
              gsap.getById("credits-reveal").kill()
            }
          },
        })
        .set("#plus-container .extra-menu", {
          display: "none",
        })
    }
  }
  return (
    <Holder id="plus-button" onClick={toggle}>
      <LineHolder>
        <Line className="text l-1" />
        <Line className="text l-2" />
        <Line className="text l-3" />
      </LineHolder>
    </Holder>
  )
}
const Credits = () => {
  const Signature = () => {
    const Holder = styled.div`
      ${rr("padding-top", "vh", 27)}
      svg {
        width: 60vw;
      }
    `
    return (
      <Holder>
        <SignatureSvg />
      </Holder>
    )
  }
  const Recipies = styled.h2`
    font-size: 10em;
    color: #ffffff;
    padding-bottom: 0.1em;
    ${rr("padding-top", "vh", 35)}
    ${font.title}
  `
  const Thanks = () => {
    const Title = styled.h2`
      font-size: 25vw;
      display: block;
      text-align: center;
      white-space: wrap;
      line-height: 0.9;
      opacity: 1;
      color: ${color.white};
      ${font.title}
    `
    const Gradient = styled.span`
      position: absolute;
      width: 100%;
      height: 100%;
      mix-blend-mode: multiply;
      background-image: linear-gradient(225deg, #ff3cac 0%, #b2c960 50%, #0062a9 100%);
    `
    const Holder = styled.div`
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      background-color: #000;
      margin: 5vw;
      ${rr("padding", "vh", 10)}
    `
    return (
      <Holder>
        <Title>
          thanks
          <br />
          for your
          <br />
          time
        </Title>
        <Gradient />
      </Holder>
    )
  }
  interface link {
    title: string
    content: string
    href: string
  }
  const LinkPart: React.FC<link> = ({ title, content, href }) => {
    const Title = styled.h2`
      display: block;
      font-size: 3em;
      margin: 0.1em;
      white-space: nowrap;
      ${font.title};
      opacity: 0.5;
    `
    const Content = styled.span`
      display: block;
      font-size: 2em;
      margin: 0.07em;
      ${font.content.medium};
    `
    const Holder = styled.a`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      color: ${color.white};
      ${rr("padding", "vh", 3)}
      text-decoration: none;
      &:active {
        .content {
          text-decoration: underline;
        }
        .title {
          opacity: 1;
        }
      }
    `
    return (
      <Holder href={href} target="_blank">
        <Title className="title">{title}</Title>
        <Content className="content">{content}</Content>
      </Holder>
    )
  }
  interface custom {
    title: string
    links: {
      content: string
      href: string
    }[]
  }
  const CustomPart: React.FC<custom> = ({ title, links }) => {
    const Title = styled.h2`
      display: block;
      font-size: 3em;
      opacity: 0.5;
      margin: 0.1em;
      ${font.title};
    `
    const Link = styled.a`
      display: block;
      font-size: 2em;
      margin: 0.07em;
      text-decoration: none;
      color: ${color.white};
      ${font.content.medium};
      &:hover {
        text-decoration: underline;
      }
    `
    const Holder = styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      color: ${color.white};
      ${rr("padding", "vh", 3)}
      &:active {
        .title {
          opacity: 1;
        }
      }
    `
    var linkGroup = []
    for (var i = 0; i < links.length; i++) {
      linkGroup.push(
        <Link key={i} href={links[i].href} target="_blank">
          {links[i].content}
        </Link>
      )
    }
    return (
      <Holder>
        <Title className="title">{title}</Title>
        {linkGroup}
      </Holder>
    )
  }
  const EndMargin = styled.div`
    position: relative;
    ${rr("padding", "vh", 5.5, 2, -0.8)}
  `
  const Holder = styled.div`
    ${rr("font-size", "vw", 2.5, 2.5, 2.3)}
    /* position: relative; */
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* ${rr("height", "vh", 77, 76, 75)} */
    /* overflow-x: hidden;
    overflow-y: scroll; */
  `
  const Container = styled.div`
    position: relative;
    width: 100vw;
    ${rr("height", "vh", 77, 76, 75)}
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: ${color.black};
  `

  return (
    <Container className="credits-contianer extra-element">
      <Holder className="credits">
        <Signature />
        <Recipies>Recipes</Recipies>
        <LinkPart
          title="🎨 Colors 🎨"
          content="pigment.shapefactory.co"
          href="https://pigment.shapefactory.co/"
        />
        <LinkPart title="♣️ Icons ♣️" content="iconmonstr.com" href="https://iconmonstr.com/" />
        <LinkPart title="Fonts" content="fonts.google.com" href="https://fonts.google.com/" />
        <CustomPart
          title="💡 inspiration 💡"
          links={[
            { content: "pinterest.com", href: "https://www.pinterest.com/" },
            { content: "behance.net", href: "https://www.behance.net/" },
            { content: "awwwards.com", href: "https://www.awwwards.com/" },
            { content: "dribbble.com", href: "https://dribbble.com/" },
          ]}
        />
        <LinkPart
          title="🎲 Web Animations 🎲"
          content="greensock.com (GSAP)"
          href="https://greensock.com/gsap/"
        />
        <LinkPart
          title="💅 Styling 💅"
          content="emotion.sh"
          href="https://emotion.sh/docs/introduction"
        />
        <CustomPart
          title="🚧 Website boilerplate 🚧"
          links={[
            { content: "React Js", href: "https://reactjs.org/" },
            { content: "Gatsby Js", href: "https://www.gatsbyjs.com/" },
            { content: "Typescript", href: "https://www.typescriptlang.org/" },
            { content: "GraphQl", href: "https://graphql.org/" },
            { content: "Firebase", href: "https://firebase.google.com/" },
          ]}
        />
        <Thanks />
        <LinkPart
          title="📧 Gmail 📧"
          content="abdallaelhosini@gmail.com"
          href="mailto:abdallaelhosini@gmail.com?cc=abdallaworks@gmail.com"
        />
        <LinkPart
          title="💼 LinkedIn 💼"
          content="linkedin/abdalla-hossainy/"
          href="https://www.linkedin.com/in/abdalla-hossainy/"
        />
        <LinkPart
          title="📞 skype 📞"
          content="live:abdallaelhosini"
          href="https://join.skype.com/invite/lfFyZZk0AYBv"
        />
        <LinkPart
          title="💫 Behance 💫"
          content="behance/abdalla-hossainy"
          href="https://www.behance.net/abdalla-hossainy"
        />
        <EndMargin className="end" />
      </Holder>
    </Container>
  )
}
const MediaButtons = () => {
  const Button = styled.a`
    position: relative;
    /* margin: 1vh 3vw; */
    ${rr("margin", "", "0.7vh 7.2vw", "1vh 7.5vw", "1vh 9vw")}
    svg {
      ${rr("width", "vw ", 8, 6.5, 5)}
      transform:scale(2);
    }
  `
  const Holder = styled.div`
    width: 100vw;
    /* height: 18vh; */
    ${rr("height", "vh", 12, 13, 14)}
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* background-color: #d50000; */
  `
  return (
    <Holder className="extra-element">
      <Button href="mailto:abdallaelhosini@gmail.com?cc=abdallaworks@gmail.com" target="_blank">
        <Gmail />
      </Button>
      <Button href="https://www.linkedin.com/in/abdalla-hossainy/" target="_blank">
        <Linked />
      </Button>
      <Button href="https://msng.link/o/?abdallaelhosini@gmail.com=sk" target="_blank">
        <Skype />
      </Button>
      <Button href="https://www.behance.net/abdalla-hossainy" target="_blank">
        <Behance />
      </Button>
    </Holder>
  )
}

export default PlusContainer
